import * as React from 'react';

const NextArrowSVG = (props: any): JSX.Element => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g filter="url(#filter0_d_5_153)">
      <circle cx="20" cy="18.5" r="16" fill="white" />
    </g>
    <rect
      width="1.5"
      height="10"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 24 18.75)"
      fill="#212B36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1027 12.5L20 13.5031L24.0041 18L20 22.4969L21.1027 23.5L26 18L21.1027 12.5Z"
      fill="#212B36"
    />
    <defs>
      <filter
        id="filter0_d_5_153"
        x="0"
        y="0.5"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.760784 0 0 0 0 0.760784 0 0 0 0 0.760784 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5_153"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5_153"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default NextArrowSVG;
